<template>
    <svg id="Maps-Layers-Boundary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            v-if="!state"
            id="Outlined"
            d="M12,16.33c-.1,0-.19-.03-.28-.08L.22,8.58C.08,8.49,0,8.33,0,8.17s.08-.32.22-.42L11.72.08c.17-.11.39-.11.55,0l11.5,7.67c.14.09.22.25.22.42s-.08.32-.22.42l-11.5,7.67c-.08.06-.18.08-.28.08ZM1.4,8.17l10.6,7.07,10.6-7.07L12,1.1,1.4,8.17ZM12,20.67c-.1,0-.19-.03-.28-.08L.22,12.92c-.23-.15-.29-.46-.14-.69.15-.23.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM12.28,23.92l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,15.42c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08Z"
        />
        <path
            v-else
            id="Filled"
            d="M12,16.33c-.1,0-.19-.03-.28-.08L.22,8.58C.08,8.49,0,8.33,0,8.17s.08-.32.22-.42L11.72.08c.17-.11.39-.11.55,0l11.5,7.67c.14.09.22.25.22.42s-.08.32-.22.42l-11.5,7.67c-.08.06-.18.08-.28.08ZM12,20.67c-.1,0-.19-.03-.28-.08L.22,12.92c-.23-.15-.29-.46-.14-.69.15-.23.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM12.28,23.92l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,15.42c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08Z"
        />
        <g v-if="paint" id="Painted">
            <path
                id="Body"
                d="M12,20.67c-.1,0-.19-.03-.28-.08L.22,12.92c-.23-.15-.29-.46-.14-.69s.47-.29.69-.14l11.22,7.48,11.22-7.48c.23-.15.54-.09.69.14.15.23.09.54-.14.69l-11.5,7.67c-.08.06-.18.08-.28.08ZM12.28,23.92l11.5-7.67c.23-.15.29-.46.14-.69-.15-.23-.47-.29-.69-.14l-11.22,7.48L.78,15.42c-.23-.15-.54-.09-.69.14-.15.23-.09.54.14.69l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08Z"
            />
            <path
                id="Paintme"
                :fill="paint"
                d="M23.78,7.75L12.28.08c-.17-.11-.39-.11-.55,0L.22,7.75c-.14.09-.22.25-.22.42v1c0,.17.08.32.22.42l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0-.17-.08-.32-.22-.42Z"
            />
            <path
                id="Shadow"
                d="M23.78,8.58l-11.5,7.67c-.08.06-.18.08-.28.08s-.19-.03-.28-.08L.22,8.58c-.14-.09-.22-.25-.22-.42v1c0,.17.08.32.22.42l11.5,7.67c.08.06.18.08.28.08s.19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0,.17-.08.32-.22.42Z"
                fill="#332e2e"
                opacity=".4"
            />
        </g>
    </svg>
</template>

<script setup>
import { useState, stateProps } from '../../composables/useState';
import { usePaint, paintProps } from '../../composables/usePaint';

const props = defineProps({
    ...stateProps(),
    ...paintProps(),
});
const { state } = useState(props);
const { paint } = usePaint(props);
</script>
